import React from 'react';
import HTMLRenderer from 'react-html-renderer'

function HTMLViewer(props) {
    const { htmlContent } = props;
    return (
        <HTMLRenderer
            html={htmlContent}
        />
    );
}

export default HTMLViewer;